// Модель с api /payments_data/
export type BasketPayments = {
  payment_methods: PaymentMethod[]
  pay_selection_cards: SavedCard[]
}

// Модель поведения способа оплат
export type BasketPayment = PaymentMethod | SavedCard

export interface PaymentMethod {
  type: keyof typeof PaymentMethodName & PaymentMethodIcons
  name: string
}

export interface SavedCard {
  id: number
  expiration: string
  card_number: string
  card_holder_name: string
  brand: string
  is_expired: boolean
  type: keyof typeof PaymentMethodName & PaymentMethodIcons
}

export enum PaymentMethodType {
  PAY_SELECTION = 'pay_selection',
  CASH = 'cash',
  CARD = 'card',
  SBERBANK = 'sberbank',
  SBP = 'sbp_sberbank',
  SAVED_CARD = 'saved_card',
  FEATURE_SAVED_CARD = 'pay_selection_card_saved',
}

export enum PaymentMethodName {
  cash = 'Наличные',
  card_courier = 'Картой курьеру',
  card = 'В ресторане',
  online = 'Онлайн',
  pay_selection = 'Новой картой',
  sbp_sberbank = 'СБП',
  sberbank = 'Онлайн',
  cloud_payments = 'Онлайн',
  pay_selection_sbp_payment = 'СБП',
}

export enum PaymentMethodIcons {
  cash = 'pay-to-cash.svg',
  card = 'card-to-get.svg',
  online = 'new-card-online.svg',
  pay_selection = PaymentMethodIcons.online,
  sbp_sberbank = 'payment-sbp.svg',
  sberbank = PaymentMethodIcons.online,
  cloud_payments = PaymentMethodIcons.online,
  pay_selection_sbp_payment = 'payment-sbp.svg',
}

export enum PaymentMethodDescriptions {
  cash_courier = 'Укажите, с какой купюры необходима сдача, курьер приедет с нужной суммой',
  cash = 'Укажите с какой купюры необходима сдача.\nМы подготовим сдачу когда вы придете забрать заказ',
  card_courier = 'Курьер приедет с терминалом. Мы принимаем VISA, Mastercard, МИР',
  card = 'Оплатите картой на кассе. Мы принимаем VISA, Mastercard, МИР',
  online = 'Ввод данных карты появится после нажатия на кнопку “Оплатить”',
  sbp_sberbank = 'Необходимо установленное на телефоне приложение банка. После нажатия на кнопку “Оплатить” появится QR-код для сканирования',
  saved_card = 'Убедитесь, что на карте достаточно средств для оплаты заказа',
  pay_selection = PaymentMethodDescriptions.online,
  sberbank = PaymentMethodDescriptions.online,
  cloud_payments = PaymentMethodDescriptions.online,
}

export enum TypeCards {
  MASTER_CARD = 'MASTERCARD',
  MIR = 'MIR',
  VISA = 'VISA',
  DEFAULT = 'DEFAULT',
}

export enum TypePaySelection {
  WIDJET = 'widjet',
  SAVEDCARD = 'saved_card',
}
